import Image from "next/image";
import React from "react";

export default function bounty() {
  return (
    <>
      <div className="w-full h-auto bd-crum">
        <div className="   mx-auto px-20 py-20">
          <h2 className="py-12 text-3xl text-center text-white">Bounty</h2>
        </div>
      </div>

      <section className="  mx-auto px-6 lg:px-20 py-20">
        <div className="  flex justify-center py-8">
          <iframe
            className=" w-full aspect-video"
            src="/NiftySky_Deck.mp4"
          ></iframe>
        </div>
        <div className="flex justify-center ">
          <Image
            src="/images/space-token.png"
            alt="Picture of the author"
            width={1500}
            height={860}
          />
        </div>
      </section>
    </>
  );
}
